/* 
 * Export component file to be used on project
*/

import MenuUserInfo from './MenuUserInfo.js';
export default MenuUserInfo;
